import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const SessionTimeoutWarning = () => {
  const { showTimeoutWarning, keepSessionAlive, logout } = useAuth();
  const [countdown, setCountdown] = useState(120); // 2 minutes en secondes

  useEffect(() => {
    if (!showTimeoutWarning) {
      setCountdown(120);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showTimeoutWarning]);

  if (!showTimeoutWarning) return null;

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-md w-full p-6 animate-fade-in">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-full">
            <AlertTriangle className="text-yellow-600 dark:text-yellow-400" size={24} />
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Session Expirée
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Vous allez être déconnecté dans <strong className="text-red-600 dark:text-red-400">
                {minutes}:{seconds.toString().padStart(2, '0')}
              </strong> en raison d'inactivité.
            </p>
            
            <div className="flex gap-3">
              <button
                onClick={keepSessionAlive}
                className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                Rester Connecté
              </button>
              <button
                onClick={logout}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-medium transition-colors"
              >
                Se Déconnecter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;
